import React, { useEffect, useMemo, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Collapse,
  Container,
  Row,
  UncontrolledTooltip,
} from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import TableContainer from "../../../Components/Common/TableContainer";

import Loader from "../../../Components/Common/Loader";
import Select from "react-select";

import AOS from "aos";
import "aos/dist/aos.css";
import { superadminGetAllNotif } from "helpers/backend_helpers";
import { formatDateTime, notifType } from "helpers/globalFunction";
import Flatpickr from "react-flatpickr";
import moment from "moment";

const SuperadminNotification = () => {
  const [tableData, setTableData] = useState<any>([]);
  const [data, setData] = useState<any>({});
  const [sort, setSort] = useState("createTime");
  const [dir, setDir] = useState(-1);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [rowCount, setRowCount] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [loading, setLoading] = useState<boolean>(false);

  const [showFilter, setShowFilter] = useState<boolean>(false);
  const [filterDate, setFilterDate] = useState<any>([]);
  const [filterUserType, setFilterUserType] = useState<any>(null);
  const [filterNotifType, setFilterNotifType] = useState<any>(null);
  const [flatpickrKey, setFlatpickrKey] = useState(0);

  const getData = () => {
    setLoading(true);
    let query: any = {
      page: pagination.pageIndex,
      size: pagination.pageSize,
      sort: sort,
      dir: dir,
    };

    if (filterDate[0] && filterDate[1]) {
      query.startDate = moment(filterDate[0]).format("YYYY-MM-DD");
      query.endDate = moment(filterDate[1]).format("YYYY-MM-DD");
    }

    if (filterUserType) {
      query.userType = filterUserType.value;
    }
    if (filterNotifType) {
      query.notifType = filterNotifType.value;
    }
    superadminGetAllNotif(query)
      .then((response: any) => {
        setTableData(
          response.content.map((el: any, index: any) => {
            let tanggal = formatDateTime(el.createTime);
            return {
              ...el,
              index: index + pagination.pageIndex * pagination.pageSize + 1,
              tanggal,
            };
          })
        );
        setRowCount(response.totalElements);
        setTotalPages(response.totalPages);
      })
      .catch(() => {})
      .finally(() => {
        setLoading(false);
      });
  };

  const handleResetFilter = () => {
    setFilterDate([]);
    setFilterUserType(null);
    setFilterNotifType(null);
    setFlatpickrKey((prev) => prev + 1);
  };

  const handleToggleFilter = () => {
    if (showFilter) {
      handleResetFilter();
    }
    setShowFilter(!showFilter);
  };

  const columns = useMemo(
    () => [
      {
        header: "#",
        accessorKey: "index",
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        header: "Tanggal",
        accessorKey: "tanggal",
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        accessorKey: "userType",
        header: "Tipe User",
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        accessorKey: "notifType",
        header: "Keterangan",
        enableColumnFilter: false,
        enableSorting: false,
        cell: (cell: any) => notifType(cell.getValue()),
      },
      {
        header: "Aksi",
        cell: (cellProps: any) => {
          return (
            <div className="hstack gap-2">
              <UncontrolledTooltip
                target={`detailNotif-${cellProps.row.original._id}`}
              >
                Detail Notifikasi
              </UncontrolledTooltip>
              <button
                id={`detailNotif-${cellProps.row.original._id}`}
                className="btn btn-sm btn-soft-info edit-list"
                onClick={() => {
                  setData(cellProps.row.original);
                }}
              >
                <i className="ri-eye-fill align-bottom" />
              </button>
            </div>
          );
        },
      },
    ],
    []
  );

  const comboUserType = [
    { label: "SUPERADMIN", value: "SUPERADMIN" },
    { label: "ADMIN", value: "ADMIN" },
    { label: "MEMBER", value: "MEMBER" },
  ];

  const comboNotifType = [
    { label: "Pembuatan User Baru", value: "CREATED_USER" },
    { label: "Atur Ulang Kata Sandi", value: "RESET_PASSWORD" },
    { label: "Pembuatan Perusahaan Baru", value: "NEW_COMPANY" },
  ];

  useEffect(() => {
    AOS.init({
      easing: "ease-out-back",
      duration: 3000,
      anchorPlacement: "top-bottom",
      once: true,
    });
  }, []);

  useEffect(() => {
    getData();
  }, [pagination, sort, dir, filterUserType, filterNotifType, filterDate]);

  document.title = "Master Notifikasi";

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb
            title="Data Master Notifikasi"
            pageTitle="Master Notifikasi"
          />

          <Row>
            <Col xxl={Object.keys(data).length > 0 ? 9 : 12}>
              <Card>
                <CardHeader className="border-0">
                  <div className="d-flex align-items-center">
                    <h5 className="card-title mb-0 flex-grow-1">
                      Master Notifikasi
                    </h5>
                    <div className="flex-shrink-0">
                      <div className="d-flex gap-2 flex-wrap">
                        <button
                          className="btn btn-soft-primary btn-sm"
                          onClick={handleToggleFilter}
                        >
                          <i className="ri-filter-3-line align-bottom me-1"></i>
                          Filters
                        </button>
                      </div>
                    </div>
                  </div>
                </CardHeader>
                <CardBody className="pt-0">
                  <Collapse isOpen={showFilter}>
                    <Row className="g-3 mb-4">
                      <Col lg={3}>
                        <div>
                          <Flatpickr
                            key={flatpickrKey}
                            className="form-control"
                            options={{
                              mode: "range",
                              dateFormat: "d M Y",
                            }}
                            onChange={(e) => {
                              setFilterDate(e);
                            }}
                            value={filterDate}
                            placeholder="Pilih Tanggal"
                          />
                        </div>
                      </Col>
                      <Col lg={3}>
                        <Select
                          value={filterUserType}
                          onChange={(e: any) => {
                            setFilterUserType(e);
                          }}
                          options={comboUserType}
                          className="basic-multi-select"
                          classNamePrefix="select"
                          placeholder="Pilih Tipe User"
                          isClearable
                        />
                      </Col>
                      <Col lg={3}>
                        <Select
                          value={filterNotifType}
                          onChange={(e: any) => {
                            setFilterNotifType(e);
                          }}
                          options={comboNotifType}
                          className="basic-multi-select"
                          classNamePrefix="select"
                          placeholder="Pilih Tipe Notifikasi"
                          isClearable
                        />
                      </Col>
                      <Col lg={12}>
                        <div className="d-flex gap-2">
                          <button
                            className="btn btn-soft-secondary btn-sm"
                            onClick={handleResetFilter}
                          >
                            <i className="ri-refresh-line align-bottom me-1"></i>
                            Reset
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </Collapse>
                  <div>
                    {loading ? (
                      <Loader />
                    ) : (
                      <TableContainer
                        columns={columns}
                        data={tableData || []}
                        customPageSize={10}
                        theadClass="text-muted text-uppercase"
                        manualPagination
                        pagination={pagination}
                        pageCount={totalPages}
                        onPaginationChange={setPagination}
                        divClass="table-responsive"
                      />
                    )}
                  </div>
                </CardBody>
              </Card>
            </Col>
            {Object.keys(data).length > 0 && (
              <Col xxl={3} data-aos="fade-left">
                <Card id="company-view-detail">
                  <div className="card-body">
                    <div className="d-flex align-items-center pb-3 border-bottom border-bottom-dashed">
                      <h5 className="flex-grow-1 fw-semibold mb-0">
                        Informasi
                      </h5>
                      <div>
                        <button
                          type="button"
                          className="btn btn-soft-danger btn-icon btn-sm fs-16 close-btn-overview"
                          onClick={() => {
                            setData({});
                          }}
                        >
                          <i className="ri-close-fill align-bottom"></i>
                        </button>
                      </div>
                    </div>
                    <div className="table-responsive table-card">
                      <table className="table table-borderless mb-0">
                        <tbody>
                          <tr>
                            <td className="fw-medium">Tanggal</td>
                            <td>{formatDateTime(data?.createTime)}</td>
                          </tr>
                          <tr>
                            <td className="fw-medium">Nama User</td>
                            <td>{data?.user?.name}</td>
                          </tr>
                          <tr>
                            <td className="fw-medium">ID User</td>
                            <td>{data?.user?.noId || "10-50"}</td>
                          </tr>
                          <tr>
                            <td className="fw-medium">Pesan</td>
                            <td>{data?.message}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </Card>
              </Col>
            )}
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default SuperadminNotification;
